module.exports = __webpack_public_path__ + "media/images/icons/hit-alt-f1ec4e0701debe4bbbb5422ec3367ff1.png";